import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

const ShippingTab = ({
    product,
    handleChange,
    activeTab
}) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className={`editor-tab-content ${activeTab === "shipping" ? "active" : ""}`}>
            <div className="editor-form-section">
                <h2>{t('shippingInfo')}</h2>
                <p className="editor-form-help">This information helps calculate accurate shipping rates.</p>

                <div className="editor-form-row multiple-columns">
                    <div className="editor-form-group">
                        <label htmlFor="weight">{t('weight')} ({t('weightUnit')})</label>
                        <input
                            type="text"
                            id="weight"
                            name="shippingInfo.weight"
                            value={product.shippingInfo.weight}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="editor-form-row multiple-columns">
                    <div className="editor-form-group">
                        <label htmlFor="width">{t('width')} ({t('dimensionUnit')})</label>
                        <input
                            type="text"
                            id="width"
                            name="shippingInfo.width"
                            value={product.shippingInfo.width}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="editor-form-group">
                        <label htmlFor="height">{t('height')} ({t('dimensionUnit')})</label>
                        <input
                            type="text"
                            id="height"
                            name="shippingInfo.height"
                            value={product.shippingInfo.height}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="editor-form-group">
                        <label htmlFor="length">{t('length')} ({t('dimensionUnit')})</label>
                        <input
                            type="text"
                            id="length"
                            name="shippingInfo.length"
                            value={product.shippingInfo.length}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShippingTab;